import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0","key":"svg-0"}],["path",{"d":"M8 12h12","key":"svg-1"}],["path",{"d":"M20 6h-12a2 2 0 0 0 -2 2v2","key":"svg-2"}],["path",{"d":"M6 14v2a2 2 0 0 0 2 2h12","key":"svg-3"}]]

const IconCapStraight = createReactComponent('outline', 'cap-straight', 'CapStraight', __iconNode);

export default IconCapStraight;